import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { FormattedMessage } from "react-intl";
import AddModuleToCourseForm from "../Forms/AddModuleToCourseForm";

export default function CreateModule({
  isOpen,
  toggle,
  courseName,
  courseId,
  modules,
  reloadModules,
}) {
  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>
        <span className="fa-solid fa-circle-plus" />{" "}
        <FormattedMessage id="AddExistingModuleTo" values={{ courseName }} />
      </ModalHeader>
      <ModalBody>
        <AddModuleToCourseForm
          modules={modules}
          courseId={courseId}
          reloadModules={reloadModules}
          dismissModal={toggle}
        />
      </ModalBody>
    </Modal>
  );
}
